import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { supabase } from "../supabaseClient";

function getDefaultPath() {
    return Capacitor.isNativePlatform() ? "/home" : "/account";
}

function safeNextPath(rawNext) {
    if (!rawNext) return getDefaultPath();
    if (typeof rawNext === "string" && rawNext.startsWith("/")) return rawNext;
    return getDefaultPath();
}

export default function AuthCallback() {
    const navigate = useNavigate();
    const [status, setStatus] = useState("Finalizing sign-in…");

    useEffect(() => {
        let mounted = true;

        const finish = async () => {
            try {
                const searchParams = new URLSearchParams(window.location.search);
                const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));

                const authError =
                    searchParams.get("error_description") ||
                    hashParams.get("error_description") ||
                    searchParams.get("error") ||
                    hashParams.get("error");

                if (authError) {
                    if (mounted) setStatus(decodeURIComponent(authError));
                    return;
                }

                const code = searchParams.get("code");
                if (code) {
                    const { error } = await supabase.auth.exchangeCodeForSession(code);
                    if (error) {
                        if (mounted) setStatus(error.message || "Could not finish sign-in.");
                        return;
                    }
                }

                const { data, error } = await supabase.auth.getSession();
                if (error) {
                    if (mounted) setStatus(error.message || "Could not finish sign-in.");
                    return;
                }

                const next = safeNextPath(data?.session?.user?.user_metadata?.next);

                if (!data?.session) {
                    if (mounted) setStatus("No active session was created. Please try logging in again.");
                    return;
                }

                if (mounted) {
                    setStatus("Success. Redirecting…");
                    window.setTimeout(() => navigate(next, { replace: true }), 500);
                }
            } catch (err) {
                console.error(err);
                if (mounted) setStatus("Could not finish sign-in.");
            }
        };

        finish();

        return () => {
            mounted = false;
        };
    }, [navigate]);

    return (
        <div className="auth-shell">
            <div className="auth-card">
                <div className="auth-form">
                    <h1 className="auth-title" style={{ marginBottom: 12 }}>Account confirmation</h1>
                    <div className="auth-msg">{status}</div>
                    <div className="auth-row" style={{ justifyContent: "center" }}>
                        <Link className="auth-link" to="/login">Back to login</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
